export const FADE_IN = "Fade in";
export const FADE_OUT = "Fade out";
export const DISCRETE = "Discrete";
